module.exports = __webpack_public_path__ + "static/img/logo_footer.093907a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo_footer.png
// module id = iqF6
// module chunks = 16